import Api from '@/Api';


const buildFilterUrl = (url, opts) => {
  if(opts && opts.groupCk) {
    url += `/${opts.groupCk}`;
    if(opts.subGroupCk) {
      url += `/${opts.subGroupCk}`;
    }
  }
  return url;
}
export default class AttestationsApi extends Api {
  approveAttestations = (opts) => {
    if(opts.parentGroupId && opts.userId) {
      return this.post(`/api/v1/private/attestation/approval`,opts);
    }
    return this.post('/api/v1/private/attestation/approval');
  }

  cancelAttestationRequest = (payload) => {
    return this.put('/api/v1/private/attestation/internal', payload);
  }

  clientApproveAttestations = (payload) => {
    return this.put('/api/v1/private/attestation/approval', payload);
  }

  getHistoricalAttestations = (opts) => {
    return this.post('/api/v1/private/attestation/historical', opts);
  }

  getInternalApprovals = (opts = {}) => {
    return this.post('/api/v1/private/attestation/internal', opts);
  }

  getInternalDetails = (parentGroupCk, clientId, originatingUserId) => {
    return this.post('/api/v1/private/attestation/internal/details', { parentGroupCk, clientId, originatingUserId })
  }

  getUserAttestations = (opts) => {
    return this.get('/api/v1/private/attestation', opts);
  }

  getUserAttestationsByParentGroup = (parentGroupCk) => {
    return this.post('/api/v1/private/attestation', { parentGroupCk });
  }

  updateAttestations = (payload) => {
    return this.put('/api/v1/private/attestation', payload);
  }
  
  getClientApprovalList = (opts) => {
    let url = '/api/v1/private/attestation/approval';
    return this.get(url);
  }

  getClientApprovalDetail = (parentGroupCk, userId) => {
    console.log(`getClientApprovalDetail`, parentGroupCk, userId)
    return this.post('/api/v1/private/attestation/approval', { parentGroupCk, userId: userId.toLowerCase() });
    // return this.get(`/api/v1/private/attestation/approval`);
  }

  getUnseenCount = () => {
    return this.get('/api/v1/private/attestation/count');
  }
}
